// extracted by mini-css-extract-plugin
export default {"container":"separator_container__iPzXV","ani":"separator_ani__PfrDL"};